import { Button, Modal } from "../../../components";
import { useCustomTranslation } from "../../../helpers/translateHelpers";

interface RequestCancelConfirmModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const RequestCancelConfirmModal = ({
  onClose,
  onConfirm,
  open,
}: RequestCancelConfirmModalProps) => {
  const { t, tRequest } = useCustomTranslation();

  return (
    <Modal
      isOpen={open}
      onClose={onClose}
      title={tRequest("cancel_confirm_title")}
      className="w-[450px]"
    >
      <p>{tRequest("cancel_confirm_description")}</p>
      <div className="mt-4 flex flex-row items-center justify-between">
        <Button label={t("cancel")} onClick={onClose} />
        <Button
          type="button"
          onClick={() => onConfirm()}
          label={tRequest("cancel")}
          className="bg-error hover:bg-error text-white hover:bg-gradient-to-t hover:from-[rgba(0,0,0,0.20)] hover:to-[rgba(0,0,0,0.20)]"
        />
      </div>
    </Modal>
  );
};

export default RequestCancelConfirmModal;
